import { render, staticRenderFns } from "./explainer-pop.vue?vue&type=template&id=d5539b7e&scoped=true&"
import script from "./explainer-pop.vue?vue&type=script&lang=js&"
export * from "./explainer-pop.vue?vue&type=script&lang=js&"
import style0 from "./explainer-pop.vue?vue&type=style&index=0&id=d5539b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5539b7e",
  null
  
)

export default component.exports